import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import ThemeCustomization from "@/themes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeCustomization>
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </SnackbarProvider>
  </ThemeCustomization>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
